import Vue from 'vue'

import auth from '@websanova/vue-auth/dist/v2/vue-auth.common.js';
// import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.js';
import driverCustomAuthBearer from './customAuth.js';
import driverHttpVueResource from '@websanova/vue-auth/dist/drivers/http/vue-resource.1.x.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js';

Vue.use(auth, {
  plugins: {
    // http: Vue.axios, // Axios
    http: Vue.http, // Vue Resource
    router: Vue.router,
  },
  drivers: {
    // auth: driverAuthBearer,
    // auth: {
    //   request: function (req, token) {
    //     this.drivers.http.setHeaders.call(this, req, {
    //       Authorization: 'Bearer ' + token
    //     })
    //     // Set auth_refresh_token on every request
    //     this.drivers.http.setHeaders.call(this, req, {
    //       Refresh: this.token(this.options.refreshTokenKey)
    //     })
    //   },
    //
    //   response: function (res) {
    //     console.log("auth.resp:", JSON.stringify(res))
    //     var headers = this.drivers.http.getHeaders.call(this, res)
    //     var token = headers.Authorization || headers.authorization
    //
    //     // Set auth_refresh_token if available
    //     var refresh_token = headers.Refresh || headers.refresh
    //     if (refresh_token) this.token(this.options.refreshTokenKey, refresh_token)
    //
    //     if (token) {
    //       token = token.split(/Bearer:?\s?/i)
    //       return token[token.length > 1 ? 1 : 0].trim()
    //     }
    //   }
    // },
    auth: driverCustomAuthBearer,
    http: driverHttpVueResource,
    // http: driverHttpVueResource, // Vue Resource
    router: driverRouterVueRouter,
  },
  options: {
    rolesKey: 'role',
    stores: ['storage'],
    loginData: {
      url: 'o/auth/login'
    },
    refreshData: {
      url: 'o/auth/refresh'
    },
    notFoundRedirect: function (transition) {
      return `/404?path=${transition.path}`;
    },
    parseUserData: function (data) {
      // User response should not be wrapped in `data` container.
      return data || {};
    },
    refreshTokenKey: 'refresh_token'
  }
});


Vue.auth.can = function (key1, key2) {
  if (Vue.auth.check(key1, key2)) {
    return true
  }
  // console.log('perm not found: ', key1, key2)
  return Vue.auth.check('admin')
}

Vue.auth.isAdmin = function () {
  return Vue.auth.check('admin')
}

